import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import DashboardSideNav from './DashboardSideNav';
import s from './Dashboard.css';

const DashboardLayout = ({ children }) => (
  <Grid fluid className={cx(s.pageContainer, 'ViewProfile')}>
    <Row>
      <Col xs={12} sm={12} md={12} lg={12}>
        <div className={'dashBoardGrid'}>
          <div className={s.leftColumn}>
            <DashboardSideNav />
          </div>
          <div className={s.rightColumn}>
            {children}
          </div>
        </div>
      </Col>
    </Row>
  </Grid>
);

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withStyles(s)(DashboardLayout);
